import { makeStyles } from '@fluentui/react-components';
import Header from '../components/Header';
import PowerBIReport from '../components/PowerBIReport';
import UpdateTargetForm from '../components/UpdateTargetForm';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  },
  // Shrinks to make room for the form, but never below this floor: past it
  // the page scrolls instead of crushing the embedded report.
  report: {
    height: '87vh',
    minHeight: '400px',
  },
});

export default function Report() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.report}>
        <PowerBIReport />
      </div>
      <UpdateTargetForm />
    </div>
  );
}
